import { useState } from "react";
import { PlainObject } from "@/interfaces/common";

export function useModal<T extends PlainObject>() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [state, setState] = useState<T>({} as T);

  const openModal = (data?: T) => {
    if (data) {
      setState(data);
    }

    setIsModalOpen(true);
  };

  const closeModal = () => {
    if (Object.keys(state).length) {
      setState({} as T);
    }

    setIsModalOpen(false);
  };

  return { isModalOpen, openModal, closeModal, state };
}
